<template>
    <div class="services-container">
        <h1 class="services-title">Nuestros Servicios</h1>
        <br />
        
        <div class="row">
            <div class="col-md-4" v-for="(item, i) in servicesData" :key="i">
                <div class="services-card">
                    <div class="service">
                        <div class="image-container">
                            <img
                                :src="item.img"
                                :alt="item.name"
                                class="service-image"
                            />
                            <button class="zoom-btn" @click="openZoom(item.img, item.name)">
                                <i class="fa fa-expand"></i>
                            </button>
                        </div>
                        <div class="service-card-body">
                            <h3 class="text-center"><b>{{ item.name }}</b></h3>
                            
                            <div class="service-description">
                                <div v-for="(feature, featureIndex) in item.features" 
                                     :key="featureIndex" 
                                     class="feature-item">
                                    <i class="fa fa-check"></i> {{ feature }}
                                </div>
                            </div>

                            <div class="bg-dark p-3 rounded text-white">
                                <p class="text-justify">
                                    <small>
                                        <i>{{ item.description }}</i>
                                    </small>
                                </p>
                            </div>

                            <h2 class="text-center price" v-if="item.price > 0">${{ item.price }} MXN</h2>
                            <h2 class="text-center price" v-else>GRATUITO</h2>

                            <div class="text-center" v-if="item.price > 0">
                                <router-link
                                    class="btn btn-primary service-btn"
                                    to="/agendar_cita"
                                    @click="addToCart({
                                        id: item.id,
                                        img: item.img,
                                        name: item.name,
                                        price: item.price,
                                    })"
                                >
                                    <i class="fa fa-calendar-plus"></i>
                                    Agendar Servicio
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <br />
        
        <div class="additional-info">
            <div class="bonus-info">
                <h4><i class="fa fa-star"></i> Valor Agregado</h4>
                <p>
                    <b>Todos nuestros trabajos al final se le da una capa de repelente a las gorras para que duren más tus servicios.</b>
                </p>
            </div>
        </div>

        <!-- Reemplaza todo el modal de zoom actual con esto: -->
<div v-if="showZoom" class="zoom-modal" @click="closeZoom">
    <div class="zoom-modal-content" @click.stop>
        <div class="zoom-header">
            <h3 class="zoom-title">{{ zoomTitle }}</h3>
            <div class="zoom-controls-top">
                <button class="zoom-control-btn" @click="resetZoom" title="Zoom original">
                    <i class="fa fa-search"></i>
                    <span class="zoom-percentage">{{ Math.round(zoomLevel * 100) }}%</span>
                </button>
                <button class="zoom-close-btn" @click="closeZoom" title="Cerrar">
                    <i class="fa fa-times"></i>
                </button>
            </div>
        </div>
        
        <div class="zoom-image-container" 
             @mousemove="handleZoomMove"
             @wheel="handleZoomWheel">
            <img
                :src="zoomImage"
                :alt="zoomTitle"
                class="zoom-full-image"
                :style="{
                    transform: `scale(${zoomLevel})`,
                    transformOrigin: zoomOrigin
                }"
                ref="zoomFullImage"
            />
        </div>

        <div class="zoom-controls-bottom">
            <button class="zoom-nav-btn" @click="prevZoom" :disabled="zoomLevel <= 0.5" title="Alejar">
                <i class="fa fa-search-minus"></i>
            </button>
            
            <div class="zoom-actions">
                <button class="zoom-action-btn" @click="resetZoom" title="Zoom original (100%)">
                    <i class="fa fa-sync-alt"></i>
                    <span>100%</span>
                </button>
                <button class="zoom-action-btn" @click="fitToScreen" title="Ajustar a pantalla">
                    <i class="fa fa-compress"></i>
                    <span>Ajustar</span>
                </button>
            </div>
            
            <button class="zoom-nav-btn" @click="nextZoom" :disabled="zoomLevel >= 3" title="Acercar">
                <i class="fa fa-search-plus"></i>
            </button>
        </div>


    </div>
</div>
    </div>
</template>

<script>
import { useStore } from "vuex";

export default {
    name: 'ServicesComponent',
    data() {
        return {
            showZoom: false,
            zoomImage: '',
            zoomTitle: '',
            zoomLevel: 1,           // Agregar esta línea
            zoomOrigin: 'center center', // Agregar esta línea
            maxZoom: 3,             // Agregar esta línea
            minZoom: 0.5,           // Agregar esta línea           
            servicesData: [
                {
                    id: 1,
                    name: "Servicio de Restaurado",
                    img: require('@/img/flyers/flyer_01.jpeg'),
                    price: 170,
                    features: [
                        "Lavado completo de la gorra",
                        "Planchado y recuperación de forma", 
                        "Pintado (Negro, Rojo o Azul)",
                        "Aplicación de repelente",
                        "Sanitización interior"
                    ],
                    description: "Lavado, Planchado y Pintado: Si ya no usas tu gorra por que ha perdido color por el sol además que por el intensivo uso a perdido su forma y de ya estar muy sucia, este servicio es el que requiere tu gorra para recuperar su brillo. El Costo es $ 170.00"
                },
                {
                    id: 2,
                    name: "Solo Lavado",
                    img: require('@/img/flyers/flyer_02.jpeg'),
                    price: 60,
                    features: [
                        "Lavado especializado",
                        "Para gorras sin estructura",
                        "Materiales delicados",
                        "Aplicación de repelente",
                        "Sanitización interior"
                    ],
                    description: "Si tú crees que tu gorra solo necesita una lavada porque no tiene estructura la corona para plancharla y/o por sus materiales se podría quemar (plásticos), nosotros te la lavamos para que ande al cien. El Costo es $ 60.00"
                },
                {
                    id: 3,
                    name: "Servicio Completo",
                    img: require('@/img/flyers/flyer_03.jpeg'),
                    price: 120,
                    features: [
                        "Lavado profundo",
                        "Planchado y formado",
                        "Recuperación de estructura", 
                        "Aplicación de repelente",
                        "Sanitización interior"
                    ],
                    description: "Lavado y Planchado: Si tu gorra ya está sucia y perdió su forma por su continuo uso, este servicio le dará nuevamente su forma a su corona y su revitalizada limpieza te regresará el gusto por usarla. El Costo es $ 120.00"
                },
                {
                    id: 4,
                    name: "Curveado de Visera",
                    img: require('@/img/flyers/flyer_04.jpeg'),
                    price: 40,
                    features: [
                        "Adaptación a contorno facial",
                        "Grado personalizable",
                        "Para viseras planas",
                        "Proceso profesional",
                        "Sin dañar materiales"
                    ],
                    description: "Si compraste una gorra con la visera plana y quieres que se adapte al contorno de tu cara, podemos curvear la visera al grado que tu gustes. El Costo es $ 40.00"
                },
                {
                    id: 5,
                    name: "Solo Planchado",
                    img: require('@/img/flyers/flyer_05.jpeg'),
                    price: 60,
                    features: [
                        "Recuperación de forma",
                        "Para gorras lavadas",
                        "Uso de formadora industrial",
                        "Estructura original",
                        "Proceso rápido"
                    ],
                    description: "Si tú gorra acabo en la lavadora (jejejeje) y está ya se encuentra limpia, acércate con nosotros y le devolvemos su forma, con nuestra plancha/formadora la devolveremos a su estado original. El Costo es $ 60.00"
                },
                {
                    id: 6,
                    name: "Cambio de Botones",
                    img: require('@/img/flyers/flyer_06.jpeg'),
                    price: 50,
                    features: [
                        "Botón de repuesto",
                        "Múltiples colores disponibles",
                        "Para botones dañados/perdidos",
                        "Instalación profesional",
                        "Materiales duraderos"
                    ],
                    description: "Si el botón de tu gorra se cayó o está dañado por el uso, nosotros te lo cambiamos, contamos con diversos colores de los que puedes escoger para que tu gorra este completa. El Costo es $ 50.00"
                },
                {
                    id: 7,
                    name: "Cambio de Broches",
                    img: require('@/img/flyers/flyer_07.jpeg'),
                    price: 70,
                    features: [
                        "Para broches snapback rotos",
                        "Múltiples colores disponibles",
                        "Ajuste personalizado",
                        "Broches de calidad",
                        "Instalación garantizada"
                    ],
                    description: "Si el broche de plástico de tu gorra (snapback) se rompió por completo o le faltan dientes y quieres remplazarlo, nosotros te lo cambiamos, tenemos varios colores de los que puedes escoger, y puedas volver a usar tu gorra a la medida que más te agrada. El Costo es $ 70.00"
                },
                {
                    id: 8,
                    name: "Cambio de Broches (Otros Materiales)",
                    img: require('@/img/flyers/flyer_08.jpeg'),
                    price: 90,
                    features: [
                        "Para strapback/hebillas",
                        "Cambio a material piel",
                        "Mayor durabilidad",
                        "Mejor presentación",
                        "Instalación profesional"
                    ],
                    description: "Ahora bien, si tu gorra es de cierre de hebilla con un broche de tela o vini-piel (strapback), podemos cambiarlo por uno de piel que le da una mejor presentación y es mas duradero. El Costo es $ 90.00"
                },
                {
                    id: 9,
                    name: "Tratamientos Extra",
                    img: require('@/img/flyers/flyer_09.jpeg'),
                    price: 0,
                    features: [
                        "Antirrepelente exterior (GRATIS)",
                        "Sanitizante interior (GRATIS)",
                        "Repelente de polvo",
                        "Frescura prolongada",
                        "Incluido en servicios completos"
                    ],
                    description: "*Como un adicional que no genera costo al cliente, en CAP WAASH-Se lava ajeno, le ponemos una capa de antirrepelente de telas en el exterior para evitar que el polvo no se pegue rápido y el agua se repela y una capade sanitizante en el interior para darle una sensación de frescura a tu gorra, esto en nuestros SERVICIOS DE RESTAURADO, SERVICIOS COMPLETOS y SERVICOS DE PLANCHADO, reiterando que esto es sin costo alguno."
                }
            ]
        };
    },
    setup() {
        const store = useStore();

        const addToCart = (item) => {
            store.commit("addToCart", item);
        };

        return { addToCart };


    },
    methods: {
        
        openZoom(image, title) {
        this.zoomImage = image;
        this.zoomTitle = title;
        this.zoomLevel = 1;          // Reset zoom al abrir
        this.zoomOrigin = 'center center';
        this.showZoom = true;
        document.body.style.overflow = 'hidden';
    },
    
    closeZoom() {
        this.showZoom = false;
        this.zoomImage = '';
        this.zoomTitle = '';
        this.zoomLevel = 1;
        document.body.style.overflow = '';
    },
    
    nextZoom() {
        if (this.zoomLevel < this.maxZoom) {
            this.zoomLevel = Math.min(this.maxZoom, this.zoomLevel + 0.25);
        }
    },
    
    prevZoom() {
        if (this.zoomLevel > this.minZoom) {
            this.zoomLevel = Math.max(this.minZoom, this.zoomLevel - 0.25);
        }
    },
    
    resetZoom() {
        this.zoomLevel = 1;
        this.zoomOrigin = 'center center';
    },
    
    fitToScreen() {
        this.zoomLevel = 1;
        this.zoomOrigin = 'center center';
    },
    
    handleZoomMove(event) {
        if (this.zoomLevel <= 1) return;

        const container = event.currentTarget;
        const containerRect = container.getBoundingClientRect();
        
        const x = event.clientX - containerRect.left;
        const y = event.clientY - containerRect.top;
        
        const xPercent = (x / containerRect.width) * 100;
        const yPercent = (y / containerRect.height) * 100;
        
        this.zoomOrigin = `${xPercent}% ${yPercent}%`;
    },
    
    handleZoomWheel(event) {
        event.preventDefault();
        
        const delta = Math.sign(event.deltaY);
        const newZoom = this.zoomLevel - (delta * 0.1);
        
        this.zoomLevel = Math.max(this.minZoom, Math.min(this.maxZoom, newZoom));
        
        // Ajustar el origin basado en la posición del mouse
        if (this.zoomLevel > 1) {
            const container = event.currentTarget;
            const containerRect = container.getBoundingClientRect();
            
            const x = event.clientX - containerRect.left;
            const y = event.clientY - containerRect.top;
            
            const xPercent = (x / containerRect.width) * 100;
            const yPercent = (y / containerRect.height) * 100;
            
            this.zoomOrigin = `${xPercent}% ${yPercent}%`;
        } else {
            this.zoomOrigin = 'center center';
        }
    },
    
    handleKeydown(event) {
        if (event.key === 'Escape' && this.showZoom) {
            this.closeZoom();
        } else if (this.showZoom) {
            if (event.key === '+' || event.key === '=') {
                event.preventDefault();
                this.nextZoom();
            } else if (event.key === '-' || event.key === '_') {
                event.preventDefault();
                this.prevZoom();
            } else if (event.key === '0') {
                event.preventDefault();
                this.resetZoom();
            }
        }
    }
    },
    mounted() {
        // Agregar listener para tecla ESC
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('keydown', this.handleKeydown);

        return this.servicesData.sort((a, b) => b.price - a.price);

    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('keydown', this.handleKeydown);
    }
};
</script>

<style scoped>
/* Modal de Zoom Mejorado */
.zoom-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    cursor: pointer;
}

.zoom-modal-content {
    width: 95vw;
    height: 95vh;
    background: #1a1a1a;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    cursor: default;
    position: relative;
}

.zoom-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    background: rgba(0, 0, 0, 0.8);
    border-bottom: 1px solid #333;
}

.zoom-title {
    color: white;
    font-weight: 600;
    font-size: 1.3rem;
    margin: 0;
}

.zoom-controls-top {
    display: flex;
    align-items: center;
    gap: 10px;
}

.zoom-control-btn {
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: none;
    border-radius: 20px;
    padding: 8px 15px;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: background 0.3s ease;
    font-size: 0.9rem;
}

.zoom-control-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.zoom-percentage {
    font-weight: 600;
}

.zoom-close-btn {
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s ease;
}

.zoom-close-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.zoom-image-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 20px;
    cursor: move;
}

.zoom-full-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    transition: transform 0.1s ease;
}

.zoom-controls-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: rgba(0, 0, 0, 0.8);
    border-top: 1px solid #333;
    gap: 20px;
}

.zoom-nav-btn {
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: none;
    border-radius: 8px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s ease;
    font-size: 1.2rem;
}

.zoom-nav-btn:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.2);
}

.zoom-nav-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.zoom-actions {
    display: flex;
    gap: 10px;
}

.zoom-action-btn {
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: none;
    border-radius: 8px;
    padding: 12px 20px;
    cursor: pointer;
    transition: background 0.3s ease;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 8px;
}

.zoom-action-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.zoom-instructions {
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 10px;
}

.zoom-instructions i {
    font-size: 0.8rem;
}

/* Responsive Design para el Zoom */
@media (max-width: 768px) {
    .zoom-modal-content {
        width: 100vw;
        height: 100vh;
        border-radius: 0;
    }
    
    .zoom-header {
        padding: 10px 15px;
    }
    
    .zoom-title {
        font-size: 1.1rem;
    }
    
    .zoom-controls-bottom {
        padding: 15px;
        flex-wrap: wrap;
        justify-content: center;
        gap: 15px;
    }
    
    .zoom-actions {
        order: -1;
        width: 100%;
        justify-content: center;
        margin-bottom: 10px;
    }
    
    .zoom-instructions {
        bottom: 120px;
        font-size: 0.8rem;
        text-align: center;
        flex-direction: column;
        gap: 5px;
    }
    
    .zoom-control-btn {
        padding: 6px 12px;
        font-size: 0.8rem;
    }
}

.services-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.services-title {
    text-align: center;
    color: #2c3e50;
    font-weight: 700;
    margin-bottom: 30px;
    font-size: 2.5rem;
}

.services-card {
    border-radius: 15px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    overflow: hidden;
    margin-bottom: 30px;
    background: white;
}

.services-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.image-container {
    position: relative;
    overflow: hidden;
}

.service-image {
    width: 100%;
    height: 300px;
    object-fit: cover;
    border-bottom: 3px solid #3498db;
    transition: transform 0.3s ease;
}

.services-card:hover .service-image {
    transform: scale(1.05);
}

.zoom-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    transition: all 0.3s ease;
    backdrop-filter: blur(5px);
}

.image-container:hover .zoom-btn {
    opacity: 1;
}

.zoom-btn:hover {
    background: rgba(0, 0, 0, 0.9);
    transform: scale(1.1);
}

.zoom-btn i {
    font-size: 1rem;
}

.service-card-body {
    background-color: #ffffff;
    padding: 25px;
}

.service-card-body h3 {
    font-size: 1.4rem;
    color: #2c3e50;
    margin-bottom: 20px;
    font-weight: 600;
}

.service-description {
    margin: 20px 0;
}

.feature-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    font-size: 0.95rem;
    color: #555;
}

.feature-item i {
    color: #27ae60;
    margin-right: 10px;
    font-size: 0.9rem;
}

.price {
    color: #e74c3c;
    font-weight: 700;
    font-size: 1.8rem;
    margin: 20px 0;
}

.service-btn {
    background: linear-gradient(135deg, #3498db, #2980b9);
    border: none;
    border-radius: 25px;
    padding: 12px 30px;
    font-weight: 600;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: white;
}

.service-btn:hover {
    background: linear-gradient(135deg, #2980b9, #3498db);
    transform: scale(1.05);
    box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);
    color: white;
}

.additional-info {
    background: #f8f9fa;
    padding: 30px;
    border-radius: 15px;
    margin-top: 30px;
}

.info-section {
    margin-bottom: 25px;
    padding-bottom: 25px;
    border-bottom: 1px solid #e9ecef;
}

.info-section:last-child {
    border-bottom: none;
    margin-bottom: 0;
}

.info-section h3 {
    color: #2c3e50;
    font-size: 1.3rem;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.info-section h3 i {
    color: #3498db;
}

.info-section p {
    color: #666;
    line-height: 1.6;
    margin: 0;
}

.bonus-info {
    background: #e8f4fd;
    padding: 20px;
    border-radius: 10px;
    border-left: 4px solid #3498db;
}

.bonus-info h4 {
    color: #2c3e50;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.bonus-info h4 i {
    color: #f39c12;
}

.bonus-info p {
    color: #2c3e50;
    margin: 0;
    font-weight: 500;
}

/* Modal de Zoom */
.zoom-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    cursor: pointer;
}

.zoom-modal-content {
    width: 90vw;
    height: 90vh;
    background: #1a1a1a;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    cursor: default;
    position: relative;
}

.zoom-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: rgba(0, 0, 0, 0.8);
    border-bottom: 1px solid #333;
}

.zoom-title {
    color: white;
    font-weight: 600;
    font-size: 1.3rem;
    margin: 0;
}

.zoom-close-btn {
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s ease;
}

.zoom-close-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.zoom-image-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 20px;
}

.zoom-full-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.zoom-instructions {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 10px;
}

.zoom-instructions i {
    font-size: 0.8rem;
}

/* Responsive Design */
@media (max-width: 768px) {
    .services-container {
        padding: 15px;
    }
    
    .services-title {
        font-size: 2rem;
    }
    
    .service-card-body {
        padding: 20px;
    }
    
    .service-card-body h3 {
        font-size: 1.2rem;
    }
    
    .price {
        font-size: 1.5rem;
    }
    
    .additional-info {
        padding: 20px;
    }
    
    .zoom-modal-content {
        width: 95vw;
        height: 95vh;
    }
    
    .zoom-title {
        font-size: 1.1rem;
    }
}

@media (max-width: 480px) {
    .services-title {
        font-size: 1.8rem;
    }
    
    .feature-item {
        font-size: 0.9rem;
    }
    
    .service-btn {
        padding: 10px 20px;
        font-size: 0.9rem;
    }
    
    .zoom-btn {
        opacity: 1; /* Siempre visible en móviles */
    }
}
</style>